var helper = {
  formatDesc(str) {
    if (str.charAt(0) === '"') {
      str = str.substr(1, str.length - 1);
    }
    if (str.charAt(str.length - 1) === '"') {
      str = str.substr(0, str.length - 2);
    }
    return str.replace(/(?:\\[rn])+/g, "<br>");
  },
  formatMoney(amount, decimalCount = 0, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  },
  polyfillPerformanceForIE(){
    if ("performance" in window == false) {
      window.performance = {};
    }

    Date.now =
      Date.now ||
      function() {
        return new Date().getTime();
      };

    if ("now" in window.performance == false) {
      var nowOffset = Date.now();

      if (performance.timing && performance.timing.navigationStart) {
        nowOffset = performance.timing.navigationStart;
      }

      window.performance.now = function now() {
        return Date.now() - nowOffset;
      };
    }
  }
};

export default helper;



// WEBPACK FOOTER //
// ./src/helper.js